import { render, staticRenderFns } from "./ThanhNT.vue?vue&type=template&id=eb5a812c"
import script from "./ThanhNT.vue?vue&type=script&lang=js"
export * from "./ThanhNT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb5a812c')) {
      api.createRecord('eb5a812c', component.options)
    } else {
      api.reload('eb5a812c', component.options)
    }
    module.hot.accept("./ThanhNT.vue?vue&type=template&id=eb5a812c", function () {
      api.rerender('eb5a812c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/ThanhNT.vue"
export default component.exports